/**
 * Reenvío puntual de comunicaciones de dividendos con bounce (AXA).
 * Poner ENABLE_AXA_DIVIDEND_BOUNCE_RETRY en false cuando termine el reenvío.
 */
export const ENABLE_AXA_DIVIDEND_BOUNCE_RETRY = true;

/** _id de la operación de dividendos a la que aplica el filtro de reenvío. */
export const AXA_DIVIDEND_BOUNCE_OPERATION_ID = '6a4221a8e6f3ac89cdca50c1';

/** Emails únicos permitidos para el reenvío (whitelist). */
export const AXA_DIVIDEND_BOUNCE_ALLOWED_EMAILS = [
  'angelsb@xydirect.com',
  'lluis@teixidor.cat',
  'isabel@recimatica.com',
  'josellorden14@movistar.es',
  'axasegurosgeneralessadesegurosyreaseguros0001@axa.es',
  'rat@girona.com',
  'rodriguezarias53@yahoo.es',
  'psaumoy@srbasesores.com',
  'josepcatasus@catalunya.org',
  'alexmora@teleline.es',
  'carlosolle@transportsmontsant.net',
  'antoniodomingo@yahoo.es',
  'eromans@grupoacmarca.com',
  'juantolino@telefonica.net',
  'fdoggez@gmail.com',
  'josena@yahoo.com',
  'jvivesb@yahoo.es',
  'miquelhv@yahoo.es',
  'pere@jofra.cat',
  'vsalles@gestinel.com',
  'tonisole2001@yahoo.es',
  'carlossainzrozas@teleline.es',
  'josefontgallart@novahumanitas.org',
  'mariaguixcampas@gmail.com',
  'cescpascual@yahoo.es',
  'jlopez@agrupacio.es',
  'josepcastanyer@yahoo.es',
  'tuent@ancla.net',
  'assagir@mugenat.es',
  'hatcat@teleline.es',
  'isabelbuxeres@telefonica.net',
  'pedro.rocasisquella@yahoo.es',
  'francescgiralt@hotmail.com',
  '932105462@infonegocio.com',
  'jcojrguezrubio@telefonica.net',
  'fhernandez@mc-mutual.com',
  'ilergeta61@hotmail.com',
];
